export default __webpack_public_path__ + "static/media/Gustixa - falling in love (ft. Yara Fabricante).84201776.mp3";